import _ from "lodash"
import defaultMessages from "../../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Configuraciones para {locationName}',

            dlgEditSettingsTitle: "Configuraciones ",
            btnSave: 'ACTUALIZAR',
            btnCancel: 'CANCELAR',

            headerItemType: "Tipo de configuración",
            headerDescription: "Descripción",
            headerSlotTime: "Tiempo mínimo de reserva",
            headerMaxTime: "Tiempo máximo de recurrencia",
            headerCheckInBefore: "Minutos para confirmar (antes)",
            headerCheckInAfter: "Minutos para confirmar (después)",
            headerAction: "Acciones",

            lblMinutes: "Período mínimo de reserva",
            lblMinutesInfo: "Periodo de tiempo mínimo, en minutos, que se permite reservar.",
            lblMaxRecurrency: "Junta recurrente. ",
            lblMaxRecurrencyInfo: "Tiempo máximo permitido para crear reservas recurrentes",
            lblCheckinBefore: "CHECKIN antes de la reserva",
            lblCheckinBeforeInfo: "Tiempo en minutos permitido para realizar CHECKIN antes de iniciar la junta.",
            lblCheckinAfter: "CHECKIN despues de la reserva",
            lblCheckinAfterInfo: "Tiempo en minutos permitido para realizar CHECKIN una vez iniciada la junta.",

            minutesTitle: "{minutes} minutos",
            maxRecurrencyTitle: "{month} mes(es)",
            checkinBeforeTitle: "{minutes} minutos",
            checkinAfterTitle: "{minutes} minutos"
        },
        en: {
            moduleTitle: "{locationName}'s settings",
            dlgEditSettingsTitle: "Settings",
            btnSave: 'UPDATE',
            btnCancel: 'CANCEL',

            headerItemType: "Setting type",
            headerDescription: "Description",
            headerSlotTime: "Min time to schedule",
            headerMaxTime: "Maximun recurrency time",
            headerCheckInBefore: "Max time to CHECKING (before)",
            headerCheckInAfter: "Max time to CHECKIN (after)",
            headerAction: "Acciones",

            lblMinutes: "Minimun time to schedule",
            lblMinutesInfo: "Minimun time allowed to schedule a reservation",
            lblMaxRecurrency: "Recurrent schedule",
            lblMaxRecurrencyInfo: "Maximun time allowed to create recurring reservations",
            lblCheckinBefore: "CHECKIN before reservation start",
            lblCheckinBeforeInfo: "Maximun time allowed to CHECKIN before reservation start",
            lblCheckinAfter: "CHECKIN after reservation started",
            lblCheckinAfterInfo: "Maximun time allowed to CHECKIN after reservation started",

            minutesTitle: "{minutes} minutes",
            maxRecurrencyTitle: "{month} month(s)",
            checkinBeforeTitle: "{minutes} minutes",
            checkinAfterTitle: "{minutes} minutes"
        }
    }
}

export default _.merge(messages, defaultMessages)